export default __webpack_public_path__ + "static/media/agrivore_icon_not_found.2d55e3a1.png";